import type { ReactElement } from "react";
import { useMemo, useState } from "react";

import ListPreLoaderItem from "app/pages/sales-intelligence/common-components/ListPreLoaderItem/ListPreLoaderItem";
import { EnrichedItem } from "app/pages/sales-intelligence/modules/enrichment/components/EnrichmentHistoryModal/components/EnrichedItem";
import {
    StyledEnrichedContentWrapper,
    StyledEnrichedItemWrapper,
    StyledEnrichmentHistoryContainerWrapper,
    StyledEnrichmentHistoryPagination,
    StyledModalBodyWrapper,
} from "app/pages/sales-intelligence/modules/enrichment/containers/EnrichmentHistoryContainer/styles";
import useEnrichmentList from "app/pages/sales-intelligence/modules/enrichment/queries/useEnrichmentList";
import { EnrichmentStatus } from "app/pages/sales-intelligence/modules/enrichment/store/type";
import Pagination from "app/pages/sales-intelligence/sub-modules/contacts-search/components/Pagination/Pagination";

const PAGE_SIZE = 10;

const EnrichmentHistoryContainer = () => {
    const { data, isLoading } = useEnrichmentList();
    const [page, setPage] = useState(1);

    const filteredData = useMemo(() => data?.filter((item) => item.status !== EnrichmentStatus.Failed) ?? [], [data]);

    const paginatedData = useMemo(() => {
        const startIndex = (page - 1) * PAGE_SIZE;
        const endIndex = startIndex + PAGE_SIZE;
        return filteredData.slice(startIndex, endIndex);
    }, [filteredData, page]);

    const renderContent = (): ReactElement | ReactElement[] => {
        if (isLoading) {
            return <ListPreLoaderItem rowNumber={3} />;
        }

        return paginatedData.map((enrichedState) => {
            return (
                <StyledEnrichedItemWrapper key={enrichedState.id}>
                    <EnrichedItem
                        iconName="csv-file"
                        enrichedState={enrichedState}
                    />
                </StyledEnrichedItemWrapper>
            );
        });
    };

    return (
        <StyledEnrichmentHistoryContainerWrapper>
            <StyledModalBodyWrapper>
                <StyledEnrichedContentWrapper>{renderContent()}</StyledEnrichedContentWrapper>
                {!isLoading && filteredData?.length > PAGE_SIZE ? (
                    <StyledEnrichmentHistoryPagination>
                        <Pagination
                            page={page}
                            pageSize={PAGE_SIZE}
                            totalCount={filteredData.length}
                            onPageChange={setPage}
                        />
                    </StyledEnrichmentHistoryPagination>
                ) : null}
            </StyledModalBodyWrapper>
        </StyledEnrichmentHistoryContainerWrapper>
    );
};

export default EnrichmentHistoryContainer;
